import FeelingTwentyPic from '../presentation/assets/books/20at60.jpg'
import AmapianoPic from '../presentation/assets/books/Amapiano.PNG'
import LegendsPic from '../presentation/assets/books/lwd.jpeg'

const books = [
    {
        id:1,
        coverPic:FeelingTwentyPic,
        name:'Feeling 20 & 60',
        description:'Put description here',
        amazonLink:'https://www.amazon.com/Feeling-20-at-Mandipa-Shumba-ebook/dp/B08JZ11MDC/ref=sr_1_2?dchild=1&keywords=mandipa+shumba&qid=1604971614&sr=8-2',
        etsyLink:'https://www.etsy.com/ca/listing/875901646/feeling-20-at-60?utm_source=OpenGraph&utm_medium=PageTools&utm_campaign=Share',

    },
    {
        id:2,
        coverPic: AmapianoPic,
        name:'Amapiano',
        description:'Put description here',
        amazonLink:'',
        etsyLink:'https://www.etsy.com/ca/listing/896352511/amapiano?ref=shop_home_active_1&frs=1',

    },
    {
        id:3,
        coverPic:LegendsPic ,
        name:'Legends with dreams: Edition one ',
        description:'Put description here',
        amazonLink:'https://www.amazon.ca/Legends-dreams-untold-Mandipa-Shumba-ebook/dp/B084366WY5',
        etsyLink:'https://www.etsy.com/ca/listing/871806804/legends-with-dreams?click_key=d79049333019174d45cce746b559c0ef9226d071%3A871806804&click_sum=9c8566cf&ref=pla_sameshop_listing_top-2&frs=1',

    },
    {
        id:4,
        coverPic:'' ,
        name:'Victory vs. Purpose',
        description:'Put description here',
        amazonLink:'https://www.amazon.com/gp/product/B078K411PV/ref=dbs_a_def_rwt_bibl_vppi_i2',
        etsyLink:'https://www.etsy.com/ca/listing/871795256/victory-vs-purpose?frs=1',

    }
]

export async function getBooks() {
   // console.log(books);
    return books;
}
